import { render } from "./batchOrderInfoDialog.vue?vue&type=template&id=4c58e2e1&scoped=true"
import script from "./batchOrderInfoDialog.vue?vue&type=script&lang=js"
export * from "./batchOrderInfoDialog.vue?vue&type=script&lang=js"

import "./batchOrderInfoDialog.vue?vue&type=style&index=0&id=4c58e2e1&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c58e2e1"]])

export default __exports__